export enum ChangeType {
  added,
  removed,
  unchanged
}
